export default __webpack_public_path__ + "static/media/litho-templates-library-05.7906382f.jpg";